import { Inject, Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';

import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { IAppSettings, IEnvironment, IResidentAppWhiteLabelResponse } from '../../../models';
import { appSettingsConverter } from './app-settings.converter';
import { appSettingsQuery } from '../../../queries';
import { SKIP_AUTH } from '../../interceptors/auth.interceptor';

@Injectable()
export class AppSettingsFacade {
  constructor(
    private apollo: Apollo,
    @Inject('ENVIRONMENT') private environment: IEnvironment
  ) {}

  public getAppSettings(): Observable<IAppSettings> {
    return this.apollo
      .query<{ getWhiteLabelSettings: IResidentAppWhiteLabelResponse }>({
        query: appSettingsQuery,
        context: { httpContext: new HttpContext().set(SKIP_AUTH, true) },
      })
      .pipe(
        map(response => response?.data?.getWhiteLabelSettings),
        map(appSettingsConverter.fromDto),
        catchError((error: Error) => {
          throw new Error(error.message);
        })
      );
  }
}
